import { render, staticRenderFns } from "./curvaLayout.vue?vue&type=template&id=61810f58&"
import script from "./curvaLayout.vue?vue&type=script&lang=js&"
export * from "./curvaLayout.vue?vue&type=script&lang=js&"
import style0 from "./curvaLayout.vue?vue&type=style&index=0&id=61810f58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports